import { gql } from '@/__generated__';

export const GET_MOVEMENT_DATA = gql(`#graphql
  query GetMovementData($movementId: String!) {
    gateMovement(id: $movementId) {
      gate {
        id
        movements2 {
          id
          lastPosition
          unit
          precision
          operatingState
        }
      }
      ...GateMovementFragment
    }
  }
`);
